import { Box, Paper, Grid } from '@mui/material';
import { PartsList } from '@features/manageWorkOrder/manageParts';
import { ChargesList } from '@features/manageWorkOrder/manageCharges';
import type { WorkOrderPart } from '@features/manageWorkOrder';
import type { WorkOrderCharge } from '@features/manageWorkOrder/manageCharges/types/charges.types';

type Props = {
  parts: WorkOrderPart[];
  charges: WorkOrderCharge[];
  jobNumber: string;
  hidePricing?: boolean;
};

export const ReviewPartsAndCharges = ({
  parts,
  charges,
  jobNumber,
  hidePricing = false
}: Props) => {
  const hasParts = parts.length > 0;
  const hasCharges = charges.length > 0;
  const showCharges = hasCharges && !hidePricing;

  if (!hasParts && !showCharges) {
    return null;
  }

  return (
    <Box sx={{ mt: 2 }}>
      <Grid container spacing={2} alignItems="stretch">
        {hasParts && (
          <Grid item xs={12} md={showCharges ? 6 : 12}>
            <Paper
              elevation={1}
              sx={{
                p: { xs: 2, sm: 2, md: 3 },
                borderRadius: 2,
                height: '100%'
              }}
            >
              <PartsList
                parts={parts}
                isLoading={false}
                jobNumber={jobNumber}
                isReadOnly
                hidePricing={hidePricing}
              />
            </Paper>
          </Grid>
        )}

        {showCharges && (
          <Grid item xs={12} md={hasParts ? 6 : 12}>
            <Paper
              elevation={1}
              sx={{
                p: { xs: 2, sm: 2, md: 3 },
                borderRadius: 2,
                height: '100%'
              }}
            >
              <ChargesList
                charges={charges}
                isLoading={false}
                jobNumber={jobNumber}
                isReadOnly
              />
            </Paper>
          </Grid>
        )}
      </Grid>
    </Box>
  );
};
